/**
 * all下行报文的封装
 */

import gift from '../gift/giftlist';
import levels from './levels';
import lang from '../../lang/index';

module.exports = {

    // 此数据在退出直播间时, 需要重新初始化
    msgbox: {
        continuousGiftMsg: {},
        staticGiftAnimQueue: [],
        checkContinuousGiftTimer: {}
    },

    pokemonbox: {
        continuousGiftMsg: {},
        checkContinuousGiftTimer: {}
    },

    pokemon: {
        giftIdArr: [2001, 2002, 2003],
        clickGiftIdArr: [2005],
        ballGiftIdArr: [2000, 2053, 2054, 2057, 2058]
    },

    // 大礼物
    addBigGift(data) {
        return this.formatGift(data);
    },

    /**
     * msgResp 原始下行报文
     * cfg: {onSuccess}
     */
    formatMsg(msgResp) {

        // 0 文本聊天
        // 1 弹幕
        // 2 礼物信息
        // 5 用户共玩［精灵等］
        // 6 关注主播
        // 9 赞（需要判断是否第一次赞）
        // 11 主播暂时离开
        // 12 主播又回来了
        // 15 用户登入
        // 17 系统广播消息
        // 19 新购买守护者
        // 20 系统消息
        let mtypes = [0, 1, 2, 6, 9, 10, 11, 12, 15, 17, 19, 20];

        let formatedMsg = [];

        if (this.isTextChat(msgResp)) {
            formatedMsg = this.formatTextChat(msgResp);
        } else if (this.isFollowHost(msgResp)) {
            formatedMsg = this.formatFollow(msgResp);
        } else if (this.isLikeHost(msgResp)) {
            formatedMsg = this.formatLike(msgResp);
        } else if (this.isHostLeave(msgResp) || this.isHostBack(msgResp)) {
            formatedMsg = [{ mType: msgResp.mType }];
        } else if (this.isUserLogin(msgResp)) {
            formatedMsg = this.formatUserLogin(msgResp);
        } else if (this.isLimitSpeak(msgResp)) {
            formatedMsg = this.formatLimitSpeak(msgResp);
        } else if (this.isUnlimitSpeak(msgResp)) {
            formatedMsg = this.formatUnlimitSpeak(msgResp);
        } else if (this.isBulletTextChat(msgResp)) {
            formatedMsg = this.formatBulletMsg(msgResp);
        } else if (this.isSystemMsg(msgResp)) {
            formatedMsg = this.formatSystemMsg(msgResp);
        } else if (this.isSystemBroadcast(msgResp)) {
            formatedMsg = this.formatedSystemBroadcast(msgResp);   
        } else if (this.isNewGuard(msgResp)) {
            formatedMsg = this.formatGuard(msgResp);
        } else if (this.isUserFight(msgResp)) {
            formatedMsg = this.formatedUserFight(msgResp);
        }

        return formatedMsg;

    },
    // 是否是文本聊天
    isTextChat(data) {
        return data.mType == 0;
    },

    // 用户弹屏消息
    isBulletTextChat(data) {
        return data.mType == 1;
    },

    // 是否是礼物信息
    isGift(data) {
        return data.mType == 2;
    },

    // 是否主播退出
    isHostExit(data) {
        return data.mType == 4;
    },

    // 用户共玩游戏
    isUserFight(data) {
        return data.mType == 5;
    },

    // 是否是连续礼物
    isContinuousGift(data) {
        return data.extenseBody.isContinuous;
    },

    isDecorateGift(data){
        let giftObj = gift.getGiftObj(data.extenseBody);//gift.getGiftFromId(data.extenseBody.giftId);

        return giftObj && giftObj.type == 24;
    },
    isStaticGift(data){
        let giftObj = gift.getGiftObj(data.extenseBody);//gift.getGiftFromId(data.extenseBody.giftId);

        return giftObj && giftObj.type == 1;
    },
    isSecretGift(data){
        let giftObj = gift.getGiftObj(data.extenseBody);
        if(giftObj){
            return false;
        }else{
            return true;
        }
    },

    // 是否是的红包礼物
    isRedPacketGift(data){
        let ret = data.extenseBody.redPackets && data.extenseBody.redPackets.length > 0;
        
        return ret;
    },

    // 是否是关注主播信息
    isFollowHost(data) {
        if (data.mType == 6) {

            if (data.localAct) {
                return true;
            } else {
                if (UP.Global.getUserId() != data.sId) {
                    return true;
                }
            }
        }

        return false;
    },

    // 禁言报文
    isLimitSpeak(data) {
        return data.mType == 7;
    },

    // 禁止当前登录用户发言
    isLimitCurrentUserSpeak(data) {
        return this.isLimitSpeak(data) && UP.Global.getUserId() == data.rId;
    },

    // 解禁言报文
    isUnlimitSpeak(data) {
        return data.mType == 8;
    },

    // 当前登录用户发言解除禁言
    isUnlimitCurrentUserSpeak(data) {
        return this.isUnlimitSpeak(data) && UP.Global.getUserId() == data.rId;
    },

    // 是否是点赞信息
    isLikeHost(data) {
        return data.mType == 9;
    },

    // 是否是主播暂时离开
    isHostLeave(data) {
        return data.mType == 11;
    },

    // 主播又回来了
    isHostBack(data) {
        return data.mType == 12;
    },

    // 用户进入主播间
    isUserLogin(data) {
        return data.mType == 15;
    },

    // 用户离开直播间
    isUserLogout(data) {
        return data.mType == 16;
    },

    // 系统通用广播
    isSystemBroadcast(data) {
        return data.mType == 17;
    },

    isNewGuard(data) {
        return data.mType == 19;
    },

    isSystemMsg(data) {
        return data.mType == 20;
    },

    isPokemonGift(data) {
        return this.pokemon.giftIdArr.indexOf(parseInt(data.extenseBody.giftId, 10)) > -1;
    },

    isPokemonClickGift(data){
        return this.pokemon.clickGiftIdArr.indexOf(parseInt(data.extenseBody.giftId, 10)) > -1;
    },

    isPokemonBallGift(data){
        return this.pokemon.ballGiftIdArr.indexOf(parseInt(data.extenseBody.giftId, 10)) > -1;
    },

    // 当前用户是否被强制踢出
    isForceOut(data) {
        return data.mType == 21;
    },
    // 大陆政策要求，发送消息需求绑定手机
    isNeedToBindPhone(data){
        return data.mType ==  33;
    },

    formatedSystemBroadcast(resp) {
        let arr = [];

        switch (resp.extenseBody.sbType) {
            case 0:
                // 1314个礼物的系统广播。默认值(原1314等)
                arr.push({
                    mType: '17_0', 
                    rAId:  resp.extenseBody.rAId,
                    rRoomId: resp.extenseBody.rRoomId,
                    userName: resp.extenseBody.userInfo.userName,
                    content: resp.extenseBody.content
                });
                break;
            case 1:
                // 跑马灯(1.7.0版开始使用)
                // 跑马灯 0：普通，1：酷炫
                if (resp.extenseBody.level && resp.extenseBody.level == 1) {
                    arr.push({
                        mType: '17_1_1', 
                        rAId:  resp.extenseBody.rAId,
                        rRoomId: resp.extenseBody.rRoomId,
                        userName: resp.extenseBody.userInfo.userName,
                        content: resp.extenseBody.content
                    });
                } else {
                    arr.push({
                        mType: '17_1_0',  // mType + '_' + resp.extensebody.snType + '_' + resp.extensebody.level 删除场控
                        rAId:  resp.extenseBody.rAId,
                        rRoomId: resp.extenseBody.rRoomId,
                        userName: resp.extenseBody.userInfo.userName,
                        content: resp.extenseBody.content
                    });
                }
                break;
            case 2:
                // 喇叭功能：普通，
                arr.push({
                    mType: '17_2', 
                    rAId:  resp.extenseBody.rAId,
                    rRoomId: resp.extenseBody.rRoomId,
                    userName: resp.extenseBody.userInfo.userName,
                    content: resp.extenseBody.content
                });
                break;
            case 4:
                // 喇叭功能：网页跳转，跳转到profile页面
                arr.push({
                    mType: '17_4', 
                    rAId:  resp.extenseBody.rAId,
                    rRoomId: resp.extenseBody.rRoomId,
                    userName: resp.extenseBody.userInfo.userName,
                    content: resp.extenseBody.content,
                    extJson: resp.extenseBody.extJson
                });
                break;
        }

        return arr;
    },

    formatSystemMsg(resp) {
        let arr = [];

        let userInfo = resp.extenseBody.userInfo;

        switch (resp.extenseBody.snType) {
            case 1:
                // 最佳红包手气提示
                let giftObj = gift.getGiftObj(resp.extenseBody); //gift.getGiftFromId(resp.extenseBody.giftId) || {};

                arr.push({
                    mType: '20_1',
                    rname: resp.extenseBody.rName, // 发送红包的用户
                    userName: resp.extenseBody.userInfo.userName, // 获取红包的用户
                    giftName: giftObj ? giftObj.name : lang.template('神秘礼物'),
                });
                break;
            case 2:
                if (resp.extenseBody.userLabel == 'RoomControl') {
                    arr.push({
                        mType: '20_2', // mType + '_' + resp.extensebody.snType  设置场控
                        rname: resp.extenseBody.userInfo.userName
                    });
                }
                break;
            case 3:
                if (resp.extenseBody.userLabel == 'RoomControl') {
                    arr.push({
                        mType: '20_3', // mType + '_' + resp.extensebody.snType 删除场控
                        rname: resp.extenseBody.userInfo.userName
                    });
                }
                break;
            case 4:
                // 强制某人离开房间的系统消息
                arr.push({
                    mType: '20_4', // mType + '_' + resp.extensebody.snType
                    rname: resp.extenseBody.rName,
                    userName: resp.extenseBody.userInfo.userName,
                    label: this.formatedUserLabel(resp)
                });
                break;
            default:
                // 默认处理
        }

        if (resp.extenseBody.type == 1) {
            
            let giftObj = gift.getGiftObj(resp.extenseBody);//gift.getGiftFromId(resp.extenseBody.giftId) || {};
            
            arr.push({
                mType: '20_10', //用户通知
                uid: resp.extenseBody.userInfo.uId,
                rname: resp.extenseBody.rName, // 发送红包的用户
                userName: resp.extenseBody.userInfo.userName,
                userGrade: resp.extenseBody.userInfo.userGrade,
                giftName: giftObj ? giftObj.name : lang.template('神秘礼物'),
                amount: resp.extenseBody.amount
            });
        }

        return arr;
    },

    formatGuard(resp) {
        let arr = [];

        let userInfo = resp.extenseBody.userInfo;

        arr.push({
            mType: '19', // mType + '_' + resp.extensebody.snType
            avatar: userInfo.userIcon,
            money: resp.extenseBody.money,
            userName: userInfo.userName
        });
        
        return arr;
    },

    // 文本信息格式化
    formatTextChat(resp) {
        let arr = [];
        let curUser = UP.Global.getUser();

        let body = resp.extenseBody;

        // 普通文本消息
        if (body.uReq) {
            body.uReq.forEach((item, inx) => {
                // 当前登录用户发的消息在下行报文到达之前已经处理完毕
                // 此时屏蔽，避免重复渲染
                if (curUser.uid == item.userInfo.uId) {
                    if (!resp.localAct) {
                        return;
                    }
                }
                if (!item.content.trim()) {
                    return;
                }
                arr.push({
                    mType: resp.mType,
                    userGrade: item.userInfo.userGrade,
                    userName: item.userInfo.userName,
                    content: item.content,
                    uid: item.userInfo.uId
                });
            });
        } else if (body.userInfo) {

            // @的消息
            arr.push({
                mType: resp.mType,
                userGrade: body.userInfo.userGrade,
                userName: lang.template('<%=sname%>悄悄@<%=rname%>', {
                    sname: body.userInfo.userName,
                    rname: resp.localAct ? body.rname : UP.Global.getUser().username
                }),
                content: body.content,
                uid: body.userInfo.uId
            });
        }


        return arr;
    },

    formatBulletMsg(resp) {

        let arr = [];
        let curUser = UP.Global.getUser();

        let body = resp.extenseBody;

        // 普通文本消息
        if (body.uReq) {

            body.uReq.forEach((item, inx) => {
                // 当前登录用户发的消息在下行报文到达之前已经处理完毕
                // 此时屏蔽，避免重复渲染
                if (curUser.uid == item.userInfo.uId) {
                    if (!resp.localAct) {
                        return;
                    }
                }
                if (!item.content.trim()) {
                    return;
                }
                arr.push({
                    mType: resp.mType,
                    userGrade: item.userInfo.userGrade,
                    userName: item.userInfo.userName,
                    content: item.content,
                    userIcon: item.userInfo.userIcon,
                    uid: item.userInfo.uId
                });
            });
        } else if (body.userInfo) {
            arr.push({
                mType: resp.mType,
                userGrade: body.userInfo.userGrade,
                userName: body.userInfo.userName,
                content: body.content,
                userIcon: body.userInfo.userIcon,
                uid: body.userInfo.uId
            });
        }

        return arr;
    },

    formatedUserLabel(resp) {
        let user = resp.extenseBody.userInfo;
        let hostInfo = $.hostInfo || {};

        let label;

        if (user.uId == hostInfo.uid) {
            label = lang.template('主播');
        } else {
            if (user.userLabels && user.userLabels.length > 0) {
                if (user.userLabels.indexOf('RoomControl') > -1) {
                    label = lang.template('场控');
                } else if (user.userLabels.indexOf('Guardian') > -1) {
                    label = lang.template('守护');
                } else {
                    let vipLabel;

                    $.each(user.userLabels || [], (index, e)=>{
                        if (e.indexOf('VIP') > -1) {
                            vipLabel = e;
                            return false;
                        }
                    });

                    if (vipLabel) {
                        label = 'VIP';
                    }
                }
            }
        }

        return label;
    },

    formatLimitSpeak(resp) {
        let label = this.formatedUserLabel(resp);
        let arr = [];

        arr.push({
            mType: 7,
            rname: resp.extenseBody.rName,
            userName: resp.extenseBody.userInfo.userName,
            rId: resp.rId,
            ubConnector: resp.extenseBody.ubConnector,
            label: label
        });

        return arr;
    },

    formatUnlimitSpeak(resp) {
        let label = this.formatedUserLabel(resp);
        let arr = [];

        arr.push({
            mType: 8,
            rname: resp.extenseBody.rName,
            userName: resp.extenseBody.userInfo.userName,
            rId: resp.rId,
            ubConnector: resp.extenseBody.ubConnector,
            label: label
        });

        return arr;
    },

    // 点赞格式化
    formatLike(resp) {
        let arr = [];
        let uLikeReq = resp.extenseBody.uLikeReq;

        uLikeReq.forEach((item, inx) => {
            if (item.isFirst) {
                arr.push({
                    mType: resp.mType,
                    userGrade: item.userInfo.userGrade,
                    userName: item.userInfo.userName,
                    uid: item.userInfo.uId
                });
            }
        });

        return arr;
    },

    // 关注信息格式化
    formatFollow(resp) {
        let arr = [];
        let body = resp.extenseBody;

        return [{
            mType: resp.mType,
            userGrade: body.userInfo.userGrade,
            userName: body.userInfo.userName,
            uid: body.userInfo.uId
        }];
    },

    // 用户登入直播间信息
    formatUserLogin(resp) {
        let arr = [];
        let systemUsers = resp.extenseBody.systemUsers;
        let curUser = UP.Global.getUser();

        systemUsers.forEach((item, inx) => {
            // if (curUser.uid == item.userInfo.uId) {
            //     return;
            // }
            
            // 机器人登录
            if (item.userInfo.uType == 3) {
                return;
            }
            // 主播
            if ($.hostInfo.uid == item.userInfo.uId) {
                return;
            }
            
            let isGuardInto = $.hostGuardInfo && longToString($.hostGuardInfo.uid) == item.userInfo.uId;

            let vipLabel;
             

            $.each(item.userInfo.userLabels || [], (index, e)=>{
                if (e.indexOf('VIP') > -1) {
                    vipLabel = e;
                    return false;
                }
            });

            if (isGuardInto) {
                arr.push({
                    mType: resp.mType,
                    userName: item.userInfo.userName,
                    userGrade: item.userInfo.userGrade,
                    avatar: item.userInfo.userIcon,
                    uid: item.userInfo.uId,
                    vipLabel: vipLabel,
                    animation: 0,
                    isShowHighText: item.isShowHighText,
                    guardInto: isGuardInto
                });
            } else {

                let userGrade = item.userInfo.userGrade;

                if (userGrade >= 10) {
                    // 10级以上
                    arr.push({
                        mType: resp.mType,
                        userName: item.userInfo.userName,
                        userGrade: item.userInfo.userGrade,
                        avatar: item.userInfo.userIcon,
                        car: this.getCarByLevel(item.userInfo.userGrade),
                        vipLabel: vipLabel,
                        uid: item.userInfo.uId,
                        isShowHighText: item.isShowHighText,
                        animation: 1
                    });
                } 

                // else  if(userGrade >= 2 && userGrade < 10) {
                //     // 2~9级
                //     arr.push({
                //         mType: resp.mType,
                //         userName: item.userInfo.userName,
                //         userGrade: item.userInfo.userGrade,
                //         avatar: item.userInfo.userIcon,
                //         vipLabel: vipLabel,
                //         uid: item.userInfo.uId,
                //         animation: 1
                //     });
                // } else {
                //     // 1级
                //     if (item.userInfo.uType != 3) {
                //         arr.push({
                //             mType: resp.mType,
                //             userName: item.userInfo.userName,
                //             userGrade: item.userInfo.userGrade,
                //             avatar: item.userInfo.userIcon,
                //             vipLabel: vipLabel,
                //             uid: item.userInfo.uId,
                //             animation: 0
                //         });
                //     }
                // }
            }
        });
        
        return arr;
    },

    getCarByLevel(level) {
        let result;
        for (var i = levels.length; i--;) {
            let item = levels[i];
            if (level >= item.minLevel && level <= item.maxLevel) {
                result = item;
                break;
            }
        }
        return result;
    },

    // 是否是自己送礼物的下行信息
    isSelfGiftDown(msg) {
        return (UP.Global.getUserId() == msg.sId) && !msg.extenseBody.localAct;
    },

    isSelfBulletDown(msg) {
        return (UP.Global.getUserId() == msg.sId) && !msg.localAct;
    },
    // 礼物信息格式化
    formatGift(msgResp) {
        let arr = [];
        let curUser = UP.Global.getUser();
        let body = msgResp.extenseBody;
        let giftId = body.giftId;
        let giftObj = gift.getGiftObj(body);

        if (giftObj && giftObj.giftId) {
            let msgType = giftObj.type;

            // 门票=22
            let unavailableList = [3, 4, 5, 9, 10, 11, 14, 15, 22];

            if (unavailableList.indexOf(msgType) >= 0) {
                return;
            }

            if (body.redPackets) {
                // 红包礼物，
                let giftPicObj = gift.getGiftPicFromId(giftObj.giftId);
                
                arr.push({
                    mType: msgResp.mType,
                    userGrade: body.userInfo.userGrade,
                    userName: body.userInfo.userName,
                    count: body.numContinuous,
                    giftName: giftObj.name,  
                    giftAmount: body.giftAmount, 
                    redPackets: body.redPackets,  
                    startTime: +new Date(), // 本地记录红包收到的开始时间，用户判断红包有效期。 redPackets中的beginTime没用            
                    giftId,
                    transactionId: body.transactionId,
                    giftPic: giftPicObj ? giftPicObj.big : '',
                    avatar: body.userInfo.userIcon,
                    localAct: body.localAct,
                    uid: body.userInfo.uId,
                    giftType: body.giftType
                });
            } else if (this.isPokemonBallGift(msgResp) || this.isPokemonClickGift(msgResp) ){
                // 点击精灵 或 精灵球
                let result = {
                    mType: msgResp.mType,
                    userGrade: body.userInfo.userGrade,
                    userName: body.userInfo.userName,
                    giftName: giftObj.name,
                    count: body.numContinuous,
                    giftAmount: msgResp.giftAmount,
                    giftId,
                    giftPic: giftObj.pic ? giftObj.pic.small : '',
                    avatar: body.userInfo.userIcon,
                    localAct: body.localAct,
                    uid: body.userInfo.uId,
                    ballGiftName: gift.getPokemonBall().name,
                    giftType: body.giftType
                }

                if ($.effectivePokemon) {
                    result.refGiftName = $.effectivePokemon.giftName;
                    result.refGiftPic = $.effectivePokemon.giftPic;
                } else {
                    // 处理延迟的消灭精灵消息
                    if ($.effectivePokemonOld) {
                        result.refGiftName = $.effectivePokemonOld.giftName;
                        result.refGiftPic = $.effectivePokemonOld.giftPic;
                    }
                }

                arr.push(result); 
            } else {
                arr.push({
                    mType: msgResp.mType,
                    userGrade: body.userInfo.userGrade,
                    userName: body.userInfo.userName,
                    giftName: giftObj.name,
                    count: body.numContinuous,
                    giftAmount: msgResp.giftAmount,
                    giftId,
                    giftPic: giftObj.pic ? giftObj.pic.small : '',
                    avatar: body.userInfo.userIcon,
                    localAct: body.localAct,
                    uid: body.userInfo.uId,
                    giftType: body.giftType
                });
            }
        }else{
            //神秘礼物
            arr.push({
                mType: msgResp.mType,
                userGrade: body.userInfo.userGrade,
                userName: body.userInfo.userName,
                giftName: lang.template('神秘礼物'),
                count: body.numContinuous,
                giftAmount: msgResp.giftAmount,
                giftId,
                giftPic: "https://g.cdn.pengpengla.com/oauthgame/html5/20181108/9f85106cf7410795bf496ce29fc8ddf9.png",
                avatar: body.userInfo.userIcon,
                localAct: body.localAct,
                uid: body.userInfo.uId,
                giftType: body.giftType
            });
        }

        return arr;
    },

    formatedUserFight(resp){
        let arr = [];
        let curUser = UP.Global.getUser();
        let body = resp.extenseBody;
        let { giftId, userInfo, sendUserInfo, targetGiftId} = body; //sendUserInfo 打赏精灵用户信息; userInfo: 打赏精灵球用户信息
        let giftObj = gift.getGiftFromId(giftId) || {};

        let result = {
            type: resp.type,
            mType: resp.mType,
            action: body.action,
            energy: body.energy,
            timeLeft: body.timeLeft,
            giftCount: body.numContinuous,
            targetTransactionId: targetGiftId,
            giftId,
            giftName: giftObj.name,
            giftPic: giftObj.pic ? giftObj.pic.small : '',
            sendUserInfo: sendUserInfo,
            userInfo: userInfo,
            ballGiftName: gift.getPokemonBall().name
        }

        if ($.effectivePokemon) {
            result.refGiftName = $.effectivePokemon.giftName;
            result.refGiftPic = $.effectivePokemon.giftPic;
        }

        arr.push(result);

        return arr;
    }, 

    formatGiftForSmallAnim(msg) {
        let body = msg.extenseBody;
        let curUser = UP.Global.getUser();

        return {
            avatar: body.userInfo.userIcon,
            userName: body.userInfo.userName,
            giftId: body.giftId,
            giftCount: body.numContinuous,
            sid: msg.sId,
            localAct: body.localAct,
            giftType: body.giftType
        };
    },

    // 赠送连续礼物逻辑
    // 定时器检测
    addContinousGift(msg, staticGiftAnimation, onContinuousGiftOver) {

        let checkContinuous = (curMsgList) => {
            if (this.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId]) {
                clearTimeout(this.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId]);
                this.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId] = null;
            }
            this.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId] = setTimeout(() => {
                // 说明连续礼物已结束
                if (this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId].length == curMsgList.length) {
                    this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId] = null;
                    let formatGift = this.formatGift(msg);

                    if (formatGift) {
                        onContinuousGiftOver(formatGift);
                        this.closeStaticGiftAnimQueueUpdate(msg.sId + msg.extenseBody.giftId);
                    }
                }

            }, 5.5 * 1000);
        }

        if (!this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId]) {
            this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId] = [msg];
        } else {
            this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId].push(msg);
        }
        checkContinuous(this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId]);

        this.updateStaticGiftAnimQueue(msg, 'update');
        staticGiftAnimation();
    },

    addPokemonClickGift(msg , onContinuousGiftOver) {

        let checkContinuous = (curMsgList) => {
            let key = msg.sId + msg.extenseBody.giftId;

            if (this.pokemonbox.checkContinuousGiftTimer[key]) {
                clearTimeout(this.pokemonbox.checkContinuousGiftTimer[key]);
                this.pokemonbox.checkContinuousGiftTimer[key] = null;
            }

            this.pokemonbox.checkContinuousGiftTimer[key] = setTimeout(() => {
                // 说明连续礼物已结束
                if (this.pokemonbox.continuousGiftMsg[key].length == curMsgList.length) {
                    this.pokemonbox.continuousGiftMsg[key] = null;
                    
                    let formatGift = this.formatGift(msg);

                    if (formatGift) {
                        onContinuousGiftOver(formatGift);
                    }
                }

            }, 5.5 * 1000);
        }

        let msgKey = msg.sId + msg.extenseBody.giftId;

        if (!this.pokemonbox.continuousGiftMsg[msgKey]) {
            this.pokemonbox.continuousGiftMsg[msgKey] = [msg];
        } else {
            this.pokemonbox.continuousGiftMsg[msgKey].push(msg);
        }
        
        checkContinuous(this.pokemonbox.continuousGiftMsg[msgKey]);
    },

    // 关闭静态礼物连播序列更新入口
    // 在3s连播轮询结束后，已存在的动画序列将不再被更新
    closeStaticGiftAnimQueueUpdate(key) {
        let arr = this.msgbox.staticGiftAnimQueue;
        for (let i = 0, len = arr.length; i < len; i++) {
            let item = arr[i];
            if (!item) {
                continue;
            }
            if (key == item.sid + item.giftId) {
                item.closeUpdate = 1;
                break;
            }
        }

    },

    // 更新静态连续礼物动画播放序列(增加、更新)
    updateStaticGiftAnimQueue(msg) {
        let arr = this.msgbox.staticGiftAnimQueue;
        let hasExsit = 0;
        msg = this.formatGiftForSmallAnim(msg);

        if (!msg) {
            return;
        }
        for (let i = arr.length; i--;) {
            let item = arr[i];

            // item == null
            // 在前两个动画序列结束后，如果后面没有更多的动画序列，则当前序列会被设置为null
            // 每次接受礼物信息后，则第一时间需要补上null的位置，其次是更新、新增
            if (!item) {
                this.msgbox.staticGiftAnimQueue.splice(i, 1, msg);
                return;
            }

            if (msg.sid == item.sid && msg.giftId == item.giftId) {

                if (item.closeUpdate) {
                    break;
                }

                this.msgbox.staticGiftAnimQueue.splice(i, 1, msg);

                hasExsit = 1;
                break;
            }
        }

        if (!hasExsit) {
            this.msgbox.staticGiftAnimQueue.push(msg);
        }

    },

    // 静态连续礼物动画播放序列（删除一项）
    delFromGiftAnimQueue(formatGift) {
        let arr = this.msgbox.staticGiftAnimQueue;
        for (let i = arr.length; i--;) {
            let item = arr[i];
            if (!item) {
                continue;
            }
            if (formatGift.sid == item.sid && formatGift.giftId == item.giftId) {
                // console.log(formatGift, item)
                this.msgbox.staticGiftAnimQueue.splice(i, 1);
                break;
            }
        }
    },

    delFromGiftAnimQueueByInx(inx) {
        this.msgbox.staticGiftAnimQueue.splice(inx, 1);
    },

    // 析构
    destructor() {
        this.msgbox.continuousGiftMsg = {};
        this.msgbox.staticGiftAnimQueue = [];
        for (let i in this.msgbox.checkContinuousGiftTimer) {
            if (this.msgbox.checkContinuousGiftTimer[i]) {
                clearTimeout(this.msgbox.checkContinuousGiftTimer[i]);
                this.msgbox.checkContinuousGiftTimer[i] = null;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./js/living/message/index.js